import { Cell, Row } from '@dexma/ui-components';
import { ConfigFieldType, TextInputFieldData } from 'adapter/in/common/form/types';
import TextInputContainer from 'adapter/in/common/form/Text';
import { OPTIONS } from 'adapter/in/common/widget/options';
import { validationGreaterThan, validationIsNumber } from 'adapter/in/common/utils/validation';
import i18n from 'asset/translation';
import React, { memo } from 'react';

type MinMaxGroupContainerProps = {
    getValue: (fieldName: string) => TextInputFieldData;
};

const MinMaxGroupContainer = memo((props: MinMaxGroupContainerProps) => {
    const { getValue } = props;
    return (
        <Row>
            <Cell>
                <TextInputContainer
                    configType={ConfigFieldType.OPTIONS}
                    name={OPTIONS.MIN}
                    label={i18n.t('widgets.widgetMenu.minMax.min')}
                    properties={{ maxLength: 100, placeholder: '' }}
                    footer=''
                    rules={{
                        required: true,
                        validate: {
                            isNumber: validationIsNumber,
                        },
                    }}
                />
            </Cell>
            <Cell>
                <TextInputContainer
                    configType={ConfigFieldType.OPTIONS}
                    name={OPTIONS.MAX}
                    label={i18n.t('widgets.widgetMenu.minMax.max')}
                    properties={{ maxLength: 100, placeholder: '' }}
                    footer=''
                    rules={{
                        required: true,
                        validate: {
                            isNumber: validationIsNumber,
                            greaterThanTo: validationGreaterThan(Number(getValue(OPTIONS.MIN)?.value), 'widgets.widgetMenu.minMax.min'),
                        },
                    }}
                />
            </Cell>
        </Row>
    );
});

export default MinMaxGroupContainer;
